var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      ref: "render-post",
      staticClass: "render-post hide-scrollbar render-post-pinterest",
      style: { fontSize: _vm.fontSize + "px" },
    },
    [
      _c("div", { staticClass: "post-content" }, [
        _c(
          "div",
          {
            staticClass: "post-medias media",
            class: { empty: _vm.notFile && !_vm.snippet.link },
          },
          [
            _vm._l(
              _vm.medias
                .filter(
                  (m) =>
                    ["image", "video"].includes(m.info.type2) &&
                    m.info.type !== "image/gif"
                )
                .slice(0, 1),
              function (media) {
                return _c(
                  "div",
                  {
                    key: media.id,
                    staticClass: "media",
                    style:
                      media.info.type2 == "image"
                        ? `background: url('${media.url}');`
                        : "background-color: #f7f7f7;",
                  },
                  [
                    media.info.type2 == "image"
                      ? _c("img", {
                          staticClass: "source",
                          attrs: { src: media.url, alt: "" },
                        })
                      : media.info.type2 == "video"
                      ? _c("video", {
                          staticClass: "source",
                          attrs: {
                            src: media.url,
                            alt: "",
                            muted: "",
                            playsinline: "",
                            autoplay: _vm.autoplayVideo,
                            loop: "",
                            preload: "metadata",
                            onloadedmetadata: "this.muted = true",
                          },
                          domProps: { muted: true },
                        })
                      : _vm._e(),
                  ]
                )
              }
            ),
            _vm.notFile && _vm.snippet.link
              ? _c("SnippetNetwork", { attrs: { link: _vm.snippet.link } })
              : _vm._e(),
            _vm.snippet.link
              ? _c("div", { staticClass: "domaine-redirection" }, [
                  _c("i", { staticClass: "fa-solid fa-arrow-up-right" }),
                  _c("p", [_vm._v(_vm._s(_vm.getHostname(_vm.snippet.link)))]),
                ])
              : _vm._e(),
          ],
          2
        ),
        _c("div", { staticClass: "post-title" }, [
          _c("p", {
            domProps: {
              innerHTML: _vm._s(_vm.titleTranslateMentionAndHastag || "Titre"),
            },
          }),
        ]),
        _c("div", { staticClass: "post-text" }, [
          _c("p", {
            domProps: {
              innerHTML: _vm._s(
                _vm.textTranslateMentionAndHastag || "Description"
              ),
            },
          }),
        ]),
        _c("div", { staticClass: "post-page" }, [
          _c(
            "div",
            { staticClass: "img-pages" },
            [
              _vm._l(
                _vm.pages.slice(0, _vm.pages.length == 4 ? 4 : 3),
                function (page, index) {
                  return [
                    _c(
                      "Tooltip",
                      {
                        key: index,
                        attrs: {
                          active: page.iconEdited,
                          text: "Voir les modifications apportées",
                          position: "right",
                          classCustom: `page ${
                            page.iconEdited ? "iconEdited" : ""
                          }`,
                        },
                        on: {
                          click: () => {
                            page.iconEdited
                              ? _vm.$emit("clickPage", page.id)
                              : _vm.openPinterestPage(page)
                          },
                        },
                      },
                      [
                        _c("img", {
                          attrs: {
                            src:
                              page && page.avatar
                                ? page.avatar
                                : "img/avatar.jpg",
                            alt: "",
                          },
                        }),
                      ]
                    ),
                  ]
                }
              ),
              _vm.pages.length > 4
                ? _c("div", { staticClass: "page count" }, [
                    _vm._v(
                      "\n                    +" +
                        _vm._s(_vm.pages.length - 3) +
                        "\n                "
                    ),
                  ])
                : _vm._e(),
            ],
            2
          ),
          _vm.pages.length == 1
            ? _c(
                "p",
                {
                  staticClass: "name",
                  on: {
                    click: function ($event) {
                      return _vm.openPinterestPage(_vm.pages[0])
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.pages[0].name))]
              )
            : _vm._e(),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }